import { sheetScope } from "../utils/props";

type GestureDirection = "none" | "horizontal" | "vertical";

export const interactionScope = /*           */ sheetScope.scope("interaction");

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const lockGestureDirection = (
  currentDirection: GestureDirection,
  deltaY: number,
  deltaX: number,
  isScrolling: boolean,
): GestureDirection => {
  if (currentDirection !== "none") {
    return currentDirection;
  }

  const totalMovement = Math.abs(deltaY) + Math.abs(deltaX);
  const MOVEMENT_THRESHOLD = 5;

  if (totalMovement <= MOVEMENT_THRESHOLD) return currentDirection; /*              */

  const isVertical = Math.abs(deltaY) > Math.abs(deltaX);

  if (!isVertical) {
    return "horizontal";
  } else if (!isScrolling) {
    return "vertical";
  }

  /*                                                                        */
  /*                                                 */
  return currentDirection; /*             */
};
